export default __webpack_public_path__ + "static/media/concept2.c23ea40f.png";